import React from 'react';
import ReactDOM from 'react-dom/client';
//import App from './App';
import AppMain from './AppMain';

import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './app/store';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
      <BrowserRouter>
         <AppMain />
      </BrowserRouter>
  </Provider>
);

